import React, { useState, ChangeEvent, FormEvent } from 'react'
import { Heading, Button, Text, Box, Checkbox } from '@workwhile/ui'
import api from '../../api'

const InvoiceSync: React.FC = () => {
  const [file, setFile] = useState<File | null>(null)
  const [message, setMessage] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [isDryRun, setIsDryRun] = useState<boolean>(true)

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files && e.target.files[0]
    if (selectedFile) {
      setFile(selectedFile)
      setMessage('')
    }
  }

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!file) {
      setMessage('Error: Please select a file before uploading.')
      return
    }

    const formData = new FormData()
    formData.append('invoice_data', file)

    setLoading(true)

    try {
      const response = await api.post(
        `/admin/charges/invoice/sync?dry_run=${isDryRun}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )

      setMessage(
        response.data && response.data.length > 0
          ? response.data
          : 'No changes were made.'
      )
    } catch (error: any) {
      setMessage(
        'Error syncing invoices: ' +
          (error.response?.data?.message || error.message)
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box m={30}>
      <Heading>Sync Invoices</Heading>
      <Text fontSize={18} whiteSpace="pre-line">
        Download the "Paid Invoice Export" from Quickbooks as a CSV file and
        upload it here to update payment statuses in the business portal. Large
        files may take a few minutes to process.
      </Text>
      <br />
      <br />
      <form onSubmit={handleSubmit}>
        <Box mb={20}>
          <Checkbox
            value={isDryRun}
            onChange={() => setIsDryRun(!isDryRun)}
            style={{ marginLeft: '10px' }}
          >
            <Text>Dry Run</Text>
          </Checkbox>
          <Text color="lightText" fontSize={14} mt={2}>
            Use "Dry Run" to preview changes before applying them.
            <br />
            If checked, this will validate the data and show you which invoices
            would be marked as paid without actually updating them.
          </Text>
        </Box>
        <Box mb={20}>
          <input type="file" onChange={handleFileChange} accept=".csv" />
        </Box>
        <Box mt={20}>
          <Button type="submit" loading={loading}>
            Sync Invoice Statuses
          </Button>
        </Box>
      </form>
      {message ? (
        <Box mt={20}>
          {Array.isArray(message) ? (
            message.map((line, index) => (
              <Text
                key={index}
                color={line.includes('Error') ? 'red' : 'green'}
                mb={2}
              >
                {line}
              </Text>
            ))
          ) : (
            <Text color={message.includes('Error') ? 'red' : 'green'}>
              {message}
            </Text>
          )}
        </Box>
      ) : null}
    </Box>
  )
}

export default InvoiceSync
